<template>
  <div>
    <div v-if="!isLoading" class="event-body">
      <div class="wrap">
        <div class="event-detail-top">
          <h3 class="event-d-tit">{{detailData.eventtitle}}</h3>
          <p class="event-d-date">{{detailData.startdate}} ~ {{detailData.enddate}}</p>
          <a href="#" @click.prevent="moveList(prevPage)"
             class="event-list-btn"><img src="../../assets/images/event/icon-table-listback.png" alt=""/><span>목록</span></a>
        </div>

        <div class="event-desc">
          <div class="event-desc-img">
            <img :src="detailData.detailimage | imageUrl" :alt="setAlt()">
          </div>

          <div v-if="contentList && contentList.length" class="event-desc-link">
            <ul :class="contentList.length > 1 ? 'event-row02' : 'event-row01'">
              <template v-for="(contentItem, index) in contentList">
                <li v-if="index%2 === 0" :key="index">
                  <event-content :data="contentList[index]"/>
                  <event-content :data="contentList[index+1]"/>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <paging-component :current-page="currentPage"
                      :page-count="+pageCount"
                      :limit="limit"
                      :paging-couunt="pagingCnt"
                      wrapper-class="paging-type02"
    />
  </div>
</template>

<script>
import EventContent from '@/components/customer/EventContent'
import PagingComponent from '@/components/common/PagingComponent'
import { getEventsDetail, getEventsContents } from '@/common/utils/request'
import { imageUrl } from '@/common/filters/url.filter'
import { scrollTop } from '@/common/utils/common'
import _ from 'lodash'
import axios from 'axios'
export default {
  components: {
    EventContent,
    PagingComponent
  },
  filters: {
    imageUrl
  },
  data () {
    return {
      eventId: '',
      currentPage: '1',
      prevPage: '1',
      detailData: {},
      detailListData: [],
      contentList: [],
      pageCount: 0,
      limit: 10,
      pagingCnt: 10,
      isLoading: true
    }
  },
  methods: {
    setAlt () {
      const { gift = '', eventtitle, description, startdate, enddate, announcementdate } = this.detailData
      const defaultAlt = `${eventtitle} ${description} 기간은 ${startdate}부터 ${enddate}까지 입니다.`
      const giftAlt = gift.length > 0 ? ` 이벤트 경품은 ${gift}입니다. 당첨자 발표일은 ${announcementdate}입니다.` : ''
      const fullAlt = defaultAlt + giftAlt
      return fullAlt
    },
    moveList (prevPage) {
      this.$router.push({
        name: 'event_list',
        query: {
          page: prevPage
        }
      })
    },
    initialise () {
      this.eventId = _.get(this.$route, ['query', 'eventId'], '')
      this.currentPage = Number(_.get(this.$route, ['query', 'page'], '1'))
      this.prevPage = Number(_.get(this.$route, ['query', 'prevPage'], '1'))
    },
    setData () {
      if (this.eventId) {
        this.isLoading = true
        let offset = this.limit * (this.currentPage - 1)
        const getEventDetailApi = getEventsDetail({ eventid: this.eventId })
        const getEventsContentsApi = getEventsContents({ eventid: this.eventId, contenttype: 'movie', offset, limit: this.limit })
        axios.all([getEventDetailApi, getEventsContentsApi]).then(axios.spread((eventDetailRes, eventContentRes) => {
          this.detailData = _.get(eventDetailRes, 'data', {})
          this.detailListData = _.get(eventContentRes, 'data.0.list', [])
          _.get(eventContentRes, 'data', {}).forEach(data => {
            if (data.type === 'movielist') {
              this.contentList = _.get(data, 'list', [])
              this.pageCount = data.pagecount
            }
          })
          this.isLoading = false
        }))
        scrollTop()
      }
    }
  },
  created () {
    this.initialise()
    this.setData()
  },
  watch: {
    $route () {
      this.initialise()
      this.setData()
    }
  }
}
</script>
<style lang="css" src="@/assets/css/event.css"></style>
